import { Divider, Grid, Typography } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import { IntegrationContext, IntegrationContextPayload } from '../../../../../context/integrationContext';
import { UserContext, UserContextPayload } from '../../../../../context/userContext';
import noDataFound from "../../../../../assets/CampaignNoDataFound.png"; 
import integrationStyles from "../../../../../assets/styles/componentStyles/chatbotStyles/integrations.module.scss";  
import contactStyle from "../../../../../assets/styles/componentStyles/campaignContactStyles/campaignContactStyle.module.scss"; 
import { createZohoIntegrationOrganizationChatbotAssignmentInterface, zohoTicketFields } from '../../../../../models/axiosModel';
import { ChatbotContext, ChatbotContextPayload } from '../../../../../context/chatbotContext';
import { useSearchParams } from 'react-router-dom';
import ZohoInformationCard from './zohoInformationCard';
import EmptyState from '../../../../global/emptyState'; 
import globalStyles from "../../../../../assets/styles/global.module.scss";
import { useGenericStore } from '../../../../../store/genericStore';
import { useShallow } from 'zustand/react/shallow';

interface CreateZohoIntegrationFormProps {
    setFlagCreateFormDialog: React.Dispatch<React.SetStateAction<boolean>>, 
    zoho_integration_organization_id: number | null,
} 

const CreateZohoIntegrationForm: React.FC<CreateZohoIntegrationFormProps> = (props) => { 
    
    const { setFlagCreateFormDialog, zoho_integration_organization_id } = props;
    
    const { chatBotDetails, GetChatbotDataApi } = useContext(ChatbotContext) as ChatbotContextPayload;
    const {zohoTicketFields, 
            zohoIntegrations, 
            createZohoIntegrationOrganizationChatbotAssignmentApi, 
            zohoContact, 
            setZohoContact, 
            zohoDepartment, 
            setZohoDepartment, 
            getListOfZohoContactApi, 
            getListOfZohoDepartmentApi
    } = useContext(IntegrationContext) as IntegrationContextPayload;  
    const { setFlagLoading, handleError } = useContext(UserContext) as UserContextPayload; 

    const { showSuccess } = useGenericStore(useShallow((state) => ({
        showSuccess: state.showSuccess
    })))

    const [searchParams] = useSearchParams(); 
    
    const [createZohoIntegrationPayload, setCreateZohoIntegrationPayload] = useState<createZohoIntegrationOrganizationChatbotAssignmentInterface>({
        chatbot_id: Number(searchParams.get('chatbot_id')),
        zoho_integration_organization_id: zoho_integration_organization_id ? zoho_integration_organization_id : 0,
        zoho_integration_organization_field: [],
    }) 

    const getListOfZohoContactApiCall = async (id: number) => {
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true })); 
        const res = await getListOfZohoContactApi(id); 
        if(!(res.status)){
            handleError(res);
        }
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false })); 
    } 

    const getListOfZohoDepartmentApiCall = async (id: number) => {
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true })); 
        const res = await getListOfZohoDepartmentApi(id); 
        if(!(res.status)){
            handleError(res);
        }
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false })); 
    }

    const setZohoFieldInPayload = (zohoTicketFields: zohoTicketFields[]) => {
        setCreateZohoIntegrationPayload((prev) => ({
            ...prev, 
            zoho_integration_organization_field: zohoTicketFields.sort((a,b) => a.zoho_ticket_field_seq - b.zoho_ticket_field_seq).map((ticket: zohoTicketFields) => {
                return {
                    zoho_ticket_field_id: ticket.zoho_ticket_field_id,
                    zoho_ticket_field_description: ticket.field_type_name.toLowerCase() == "string" ? "" : "",
                    zoho_ticket_field_static_value: ticket.field_type_name.toLowerCase() == "string" ? "" : "",
                }
            })
        }));
    } 

    const handleDescriptionChangeValue = (value: string, ind: number) => { 
        setCreateZohoIntegrationPayload((prev) => ({
            ...prev, 
            zoho_integration_organization_field: prev.zoho_integration_organization_field.map((ticket, index) => {
                return {
                    ...ticket, 
                    zoho_ticket_field_description: index === ind ? value : ticket.zoho_ticket_field_description,
                }
            })
        }))
    } 

    const handleStaticValueChangeValue = (value: string, ind: number) => {
        setCreateZohoIntegrationPayload((prev) => ({
            ...prev, 
            zoho_integration_organization_field: prev.zoho_integration_organization_field.map((ticket, index) => {
                return {
                    ...ticket, 
                    zoho_ticket_field_static_value: index === ind ? value : ticket.zoho_ticket_field_static_value,
                }
            })
        }))
    } 

    const checkDisableIntegrate = () => {  
        if(zohoTicketFields && zohoTicketFields.length > 0){ 
            for(let i = 0; i < zohoTicketFields.length; ++i){
                if(zohoTicketFields[i].flag_required){
                    if(createZohoIntegrationPayload.zoho_integration_organization_field[i]?.zoho_ticket_field_description?.toString().trim().length === 0)
                        return true;
                }else{
                    if(createZohoIntegrationPayload.zoho_integration_organization_field[i]?.zoho_ticket_field_static_value?.toString().trim().length === 0) 
                        return true;
                }
            } 
            return false;
        }
        return true;
    } 

    const createZohoIntegrationOrganizationChatbotAssignmentApiCall = async () => {
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }));  
        const res = await createZohoIntegrationOrganizationChatbotAssignmentApi(createZohoIntegrationPayload); 
        if(res.status){
            showSuccess("Chatbot Assigned to Zoho Account Successfully!")
            let chatbot_id = Number(searchParams.get('chatbot_id'));
            GetChatbotDataApi(chatbot_id);
        }else{
            handleError(res);
        } 
        setFlagCreateFormDialog(false)
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false })); 
    }

    const handleIntegrateClick = async () => {
        createZohoIntegrationOrganizationChatbotAssignmentApiCall();
    }  

    const handleCancelClick = () => { 
        if(zohoTicketFields) setZohoFieldInPayload(zohoTicketFields); 
        setFlagCreateFormDialog(false);
    }

    useEffect(() => {
        if(zohoTicketFields){
            setZohoFieldInPayload(zohoTicketFields);
        }
        if(!zohoContact){
            if(zohoIntegrations){
                getListOfZohoContactApiCall(zoho_integration_organization_id || 0);
            }
        } 
        if(!zohoDepartment){
            if(zohoIntegrations){
                getListOfZohoDepartmentApiCall(zoho_integration_organization_id || 0);
            }
        }
    }, []);  

  return (
    <>  
        <Grid container className={integrationStyles.zohoIntegrationGridItem}>
                <Grid item xs={12}>
                    <Grid container className={`${globalStyles.flexColumn} ${globalStyles.justifyCenter}`}>
                        <Grid item className={`${globalStyles.fullwidth} ${globalStyles.textCenter}`}>
                            <Typography className={contactStyle.popupTitleTypography}>Integrate Zoho Account</Typography>
                        </Grid>

                        <Divider className={contactStyle.popupTitleDivider} />

                        <Grid item className={integrationStyles.zohoInformationCardGridItem}>
                            {!zohoTicketFields ? 
                                <></> 
                                : 
                                zohoTicketFields.length > 0 ?
                                    <ZohoInformationCard 
                                        zohoTicketFields={zohoTicketFields} 
                                        createZohoIntegrationPayload={createZohoIntegrationPayload} 
                                        handleDescriptionChangeValue={handleDescriptionChangeValue} 
                                        handleStaticValueChangeValue={handleStaticValueChangeValue} 
                                        handleCancelClick={handleCancelClick} 
                                        handleIntegrateClick={handleIntegrateClick} 
                                        checkDisableIntegrate={checkDisableIntegrate}
                                    />
                                :
                                    <Grid item xs={12} className={integrationStyles.noTicketFieldFound}>
                                        <EmptyState
                                            height={'calc(100vh - 250px) !important'}
                                            pageIcon={<img alt="chatbot" src={noDataFound} />}
                                            pageText={"No Ticket Field Found!"}
                                        />
                                    </Grid>
                            }
                        </Grid>

                    </Grid>
                </Grid>
        </Grid>
    </>
  )
}

export default CreateZohoIntegrationForm
